<template>
  <div
    ref="menu"
    class="fixed z-[109] p-1 bg-base-100 shadow-lg rounded-lg border border-base-300 min-w-44"
    :style="{ left: `${position.x}px`, top: `${position.y}px` }"
    @mousedown.stop
  >
    <button
      v-if="resource.canView"
      class="w-full px-2 py-1 rounded-md hover:bg-base-200 text-sm text-left"
      @click="$emit('action', 'view')"
    >View</button>
    <button
      v-if="resource.canEdit"
      class="w-full px-2 py-1 rounded-md hover:bg-base-200 text-sm text-left"
      @click="$emit('action', 'edit')"
    >Edit</button>
    <button
      v-if="resource.canSend"
      class="w-full px-2 py-1 rounded-md hover:bg-base-200 text-sm text-left"
      @click="$emit('action', 'send')"
    >Send</button>
    <button
      v-if="resource.canSign"
      class="w-full px-2 py-1 rounded-md hover:bg-base-200 text-sm text-left"
      @click="$emit('action', 'sign')"
    >Sign</button>
    <hr
      v-if="resource.canAdmin"
      class="my-1 border-base-300"
    >
    <button
      v-if="resource.canAdmin"
      class="w-full px-2 py-1 rounded-md hover:bg-base-200 text-sm text-left font-medium"
      @click="$emit('manage-access')"
    >Manage Access</button>
  </div>
</template>

<script>
export default {
  name: 'ResourceContextMenu',
  props: {
    resource: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    }
  },
  emits: ['action', 'manage-access', 'close'],
  mounted () {
    document.addEventListener('mousedown', this.handleOutside)

    this.$nextTick(() => {
      const menu = this.$refs.menu
      if (!menu) return

      const rect = menu.getBoundingClientRect()
      const overflowX = rect.right - window.innerWidth
      const overflowY = rect.bottom - window.innerHeight

      if (overflowX > 0) this.position.x = Math.max(8, this.position.x - overflowX - 8)
      if (overflowY > 0) this.position.y = Math.max(8, this.position.y - overflowY - 8)
    })
  },
  beforeUnmount () {
    document.removeEventListener('mousedown', this.handleOutside)
  },
  methods: {
    handleOutside (event) {
      if (this.$refs.menu && !this.$refs.menu.contains(event.target)) {
        this.$emit('close')
      }
    }
  }
}
</script>

